import {
  BreifInfluencerV2StatusEnum,
  SORT_ORDER,
} from "@entities/brief/lib/constants";
import { ContactFilterValue } from "@features/BriefContactFilter/BriefContactFilterV2";
import { IBriefInfluencerSearchRequestV2 } from "@shared/lib/types/briefInfluencerV2";
import { Tabs } from "./types";

type ClosureInfluencerFiltersParams = {
  briefId: string;
  userId: string;
  page: number;
  limit: number;
  searchQuery: string;
  offerStatus: Tabs;
  contactFilter: ContactFilterValue;
  deliverableFilter: string[];
  dynamicFields?: IBriefInfluencerSearchRequestV2["dynamicFields"];
  sortByDynamicFields?: Record<string, SORT_ORDER>;
};

export function getClosureInfluencerFilters({
  briefId,
  userId,
  page,
  limit,
  searchQuery,
  offerStatus,
  contactFilter,
  deliverableFilter,
  dynamicFields,
  sortByDynamicFields,
}: ClosureInfluencerFiltersParams): IBriefInfluencerSearchRequestV2 {
  return {
    briefId,
    page,
    limit,
    searchQuery: searchQuery || undefined,
    status: BreifInfluencerV2StatusEnum.Purchased,
    isCreatorDeclined: Tabs.All ? undefined : false,
    isBrandDeclined: Tabs.All ? undefined : false,
    assignedPricingPocV2: userId ? [userId] : [],
    isCreatorOnboardPending: contactFilter.isCreatorOnboardingPending
      ? true
      : undefined,
    primaryContact:
      contactFilter.primaryContact.type.length > 0 ||
      contactFilter.primaryContact.agencyId.length > 0
        ? {
            type: contactFilter.primaryContact.type,
            agencyId: contactFilter.primaryContact.agencyId,
          }
        : undefined,
    isDeliverablesPending: deliverableFilter.includes("") ? true : undefined,
    deliverableV2Ids:
      deliverableFilter.filter((id) => id !== "").length > 0
        ? deliverableFilter.filter((id) => id !== "")
        : undefined,
    dynamicFields,
    sortByDynamicFields,
    ...(offerStatus === Tabs.ConfirmationPending && {
      isConfirmationSent: false,
    }),
    ...(offerStatus === Tabs.ConfirmationSent && {
      isConfirmationSent: true,
      isConfirmed: false,
    }),
    ...(offerStatus === Tabs.Confirmed && {
      isConfirmed: true,
      isConfirmationSent: true,
    }),
  };
}
